/**
 * Deal Countdown Timer
 * 
 * Simple countdown timer that displays time in HH:MM:SS format.
 * Reads end timestamp from data-end-ts attribute (in milliseconds).
 * Stops at 00:00:00 when countdown expires.
 */
(function() {
  'use strict';

  /**
   * Format remaining time as HH:MM:SS
   * Hours can exceed 23 (e.g., 48:30:15)
   * @param {number} remainingMs - Remaining time in milliseconds
   * @returns {string} Formatted time string
   */
  function formatTime(remainingMs) {
    if (remainingMs <= 0) {
      return '00:00:00';
    }

    var totalSeconds = Math.floor(remainingMs / 1000);
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    return (
      String(hours).padStart(2, '0') + ':' +
      String(minutes).padStart(2, '0') + ':' +
      String(seconds).padStart(2, '0')
    );
  }

  /**
   * Initialize a single countdown element
   * @param {HTMLElement} container - The .deal-countdown element
   */
  function initCountdown(container) {
    var endTsAttr = container.getAttribute('data-end-ts');
    if (!endTsAttr) {
      return;
    }

    var endTs = parseInt(endTsAttr, 10);
    if (isNaN(endTs)) {
      return;
    }

    var timeDisplay = container.querySelector('.js-deal-countdown-time');
    if (!timeDisplay) {
      return;
    }

    // Immediately update the display
    var remaining = endTs - Date.now();
    timeDisplay.textContent = formatTime(remaining);

    // If already expired, don't start interval
    if (remaining <= 0) {
      return;
    }

    // Update every second
    var intervalId = setInterval(function() {
      var remaining = endTs - Date.now();
      timeDisplay.textContent = formatTime(remaining);

      // Stop when countdown expires
      if (remaining <= 0) {
        clearInterval(intervalId);
      }
    }, 1000);
  }

  /**
   * Initialize all countdown elements on the page
   */
  function initAllCountdowns() {
    var countdowns = document.querySelectorAll('.deal-countdown');
    countdowns.forEach(initCountdown);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCountdowns);
  } else {
    initAllCountdowns();
  }
})();
